
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Component 9 – 97","xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 10","cx":"35","cy":"35","r":"35","fill":"#151924"}}),_c('g',{attrs:{"fill":"#acb2bf","data-name":"messages-2"}},[_c('path',{attrs:{"data-name":"Vector","d":"M43.011 41.013l.493 3.939a1.256 1.256 0 01-1.9 1.222l-4.365-2.568a.617.617 0 01-.215-.848 7.787 7.787 0 00.973-3.739c0-4.562-3.968-8.277-8.847-8.277a9.225 9.225 0 00-2.881.449.634.634 0 01-.809-.748 11 11 0 0110.853-7.915c6.167 0 11.159 4.6 11.159 10.271a10 10 0 01-4.461 8.214z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M36.428 38.92a6.143 6.143 0 01-1.491 3.994 7.057 7.057 0 01-5.46 2.49l-3.3 1.959a.791.791 0 01-1.188-.771l.316-2.49a6.3 6.3 0 01-2.777-5.182 6.349 6.349 0 013.008-5.35 7.183 7.183 0 013.943-1.15 6.732 6.732 0 016.949 6.5z"}})])])
          )
        }
      }
    